import { TestsContainer } from "../../components/TestsContainer"
import { CommonLayout } from "../../layouts/CommonLayout/CommonLayout"

export const TestsPage = () => {
    return (
        <CommonLayout>
            <TestsContainer />
        </CommonLayout>
    )
}